import { useNavigate } from 'react-router-dom';
import LibModal from '../../../../../features/LibModal/LibModal';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import Button, { ButtonPest } from '../../../../../utils/Button';
import { mkRelativeUrl } from '../../../../../utils/URL';
import { ApiMakeInitiateItem } from '../../../../Services/Pending/ServicePendingOperation';
import { useInvoiceInfo } from '../InvoiceInfoProvider';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';

function ProductDetails({ show, data }) {
    if (!show) {
        return null;
    }
    return (
        <div className="mb-3">
            <div>
                <span className="inline-block text-primary text-lg font-medium">
                    {data?.productTitle} {data?.subscriptionId !== 0 && `#${data.subscriptionId}`}
                </span>
            </div>
            <div>
                <span className="text-sm text-primary-700">{data?.productDescription}</span>
            </div>
        </div>
    );
}

export function ServiceInfoRow({ invoiceItems, invoiceData }) {
    const { handleReload } = useInvoiceInfo();
    const navigate = useNavigate();
    const { setConfirm, setMessage, setTemplateLoading } = useTemplate();

    const handleMakeInitiate = (item) => {
        setConfirm({
            text: 'Are you sure you want to make this item initiate?',
            textAction: 'Mark as Initiate',
            clickAction: () => {
                setTemplateLoading(true);
                ApiMakeInitiateItem(invoiceData?.id, item?.id)
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                        setTemplateLoading(false);
                    })
                    .catch((err) => {
                        setTemplateLoading(false);
                        setMessage({ type: 'error', text: err.toString(0) });
                    });
            }
        });
    };
    if (invoiceItems && !invoiceItems?.length) {
        return null;
    }
    return (
        <div>
            <div className="h-10">
                <h2 className="text-primary text-xl">Services</h2>
            </div>

            {invoiceItems?.map((item) => (
                <div className="mb-4" key={item.id}>
                    <ProductDetails
                        show={item?.productTitle && item?.productDescription}
                        data={item}
                    />
                    <span>
                        {item?.productType === 'service' && item?.subscriptionServiceId === 0 ? (
                            <ButtonPest
                                title="Mark as Initiate"
                                onClick={() => handleMakeInitiate(item)}
                                disabled={
                                    invoiceData?.status === 'inactive' ||
                                    invoiceData?.amountPaid === 0 ||
                                    item?.status === 'canceled'
                                }
                            />
                        ) : (
                            <ButtonPest
                                title="Go to Service"
                                onClick={() =>
                                    navigate(
                                        mkRelativeUrl(`/services/manage`, {
                                            q: item?.subscriptionServiceId
                                        })
                                    )
                                }
                            />
                        )}
                    </span>
                </div>
            ))}
        </div>
    );
}

function SubscriptionInfoRow({ invoiceItems, invoiceData }) {
    const { handleReload } = useInvoiceInfo();
    const { setConfirm, setMessage, setTemplateLoading } = useTemplate();
    const navigate = useNavigate();
    const { openModal, closeModal, modalData, modalType } = useInvoiceInfo();
    const handleMakeInitiate = (item) => {
        setConfirm({
            text: 'Are you sure you want to make this item initiate?',
            textAction: 'Mark as Initiate',
            clickAction: () => {
                setTemplateLoading(true);
                ApiMakeInitiateItem(invoiceData?.id, item?.id)
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                        setTemplateLoading(false);
                    })
                    .catch((err) => {
                        setTemplateLoading(false);
                        setMessage({ type: 'error', text: err.toString(0) });
                    });
            }
        });
    };
    if (invoiceItems && !invoiceItems?.length) {
        return null;
    }
    return (
        <div>
            <div className="h-10">
                <h2 className="text-primary text-xl">Subscriptions</h2>
            </div>
            {invoiceItems?.map((item) => {
                if (item?.productType === 'service') {
                    return (
                        <div className="mb-4" key={item.id}>
                            <ProductDetails
                                show={item?.productTitle && item?.productDescription}
                                data={item}
                            />
                            <span>
                                {item?.subscriptionServiceId ? (
                                    <Button
                                        title="Go to Services"
                                        onClick={() =>
                                            navigate(
                                                mkRelativeUrl(`/services/manage`, {
                                                    q: item?.subscriptionServiceId
                                                })
                                            )
                                        }
                                        className="bg-warning"
                                    />
                                ) : (
                                    <ButtonPest
                                        title="Mark as Initiate"
                                        onClick={() => handleMakeInitiate(item)}
                                        disabled={
                                            invoiceData?.status === 'inactive' ||
                                            invoiceData?.amountPaid === 0 ||
                                            item?.status === 'canceled' ||
                                            invoiceData?.isServiceCreatabale === false
                                        }
                                    />
                                )}
                            </span>
                        </div>
                    );
                }
                return (
                    <div className="mb-4" key={item.id}>
                        <ProductDetails
                            show={item?.productTitle && item?.productDescription}
                            data={item}
                        />
                        <span>
                            {item?.subscriptionId ? (
                                <Button
                                    title="Go to Subscription"
                                    onClick={() =>
                                        navigate(
                                            mkRelativeUrl(
                                                `/subscriptions/manage/${item?.subscriptionId}/info`
                                            )
                                        )
                                    }
                                    className="bg-warning"
                                />
                            ) : (
                                <ButtonPest
                                    title="Create Subscription"
                                    onClick={() => openModal(item?.id, item)}
                                    disabled={
                                        invoiceData?.status === 'inactive' ||
                                        invoiceData?.amountPaid === 0 ||
                                        item?.status === 'canceled'
                                    }
                                />
                            )}
                        </span>

                        {/* modal */}
                        {modalType === item?.id && (
                            <LibModal title="Create Subscription" setOpen={closeModal}>
                                <CreateSubscriptionModal data={modalData} />
                            </LibModal>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

export default SubscriptionInfoRow;
